import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject, input } from '@angular/core';
import { Loan1008Service } from 'apps/cmg-clear2-ui/src/app/loan-1008/loan-1008.service';
import { Loan1008Model } from 'apps/cmg-clear2-ui/src/app/loan-1008/models/loan-1008.model';
import { take } from 'rxjs';
import { Panel } from 'primeng/panel';
import { PrimeTemplate } from 'primeng/api';
import { EmptyToDashPipe } from '../../../pipes/empty-to-dash.pipe';
import { PhoneNumberPipe } from '../../../pipes/phone-number.pipe';
import { InfoPanelContentComponent } from '../components/info-panel-content/info-panel-content.component';
import { InfoRowComponent } from '../components/info-row/info-row.component';

@Component({
  selector: 'cmg-seller-contract-contact-information',
  templateUrl: './seller-contract-contact-information.component.html',
  styleUrls: ['./seller-contract-contact-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Panel, PrimeTemplate, EmptyToDashPipe, PhoneNumberPipe, InfoPanelContentComponent, InfoRowComponent],
})
export class SellerContractContactInformationComponent implements OnInit {
  private readonly _loan1008Service = inject(Loan1008Service);
  private readonly _cdRef = inject(ChangeDetectorRef);

  readonly fileDataId = input<number>(undefined);
  loan1008Data: Loan1008Model;

  ngOnInit(): void {
    if (this.fileDataId() > 0) {
      this._loan1008Service
        .getLoan1008data(this.fileDataId())
        .pipe(take(1))
        .subscribe((loan1008Data) => {
          this.loan1008Data = loan1008Data;
          this._cdRef.detectChanges();
        });
    }
  }

  sellerAddress(street, city, state, zip) {
    const addressParts = [];
    if (street) {
      addressParts.push(street);
    }
    if (city) {
      addressParts.push(city);
    }
    if (state) {
      addressParts.push(state);
    }
    if (zip) {
      addressParts.push(zip);
    }
    return addressParts.length > 0 ? addressParts.join(', ') : '-';
  }
}
